import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** A 32px pill (44px hit area). `dot` = sphere colour; `count` = trailing number. */
export default function Chip({
  on = false,
  dot,
  count,
  onClick,
  to,
  label,
  children,
}: {
  on?: boolean;
  dot?: string;
  count?: number;
  onClick?: () => void;
  to?: string;
  /** aria-label when the text alone is ambiguous. */
  label?: string;
  children: ReactNode;
}): JSX.Element {
  const inner = (
    <>
      {dot && <span className="ui-dot" style={{ background: dot }} aria-hidden="true" />}
      {children}
      {count !== undefined && <span className="ui-chip__count">{count}</span>}
    </>
  );
  const className = `ui-chip${on ? ' ui-chip--on' : ''}`;
  if (to) {
    return (
      <Link to={to} className={className} aria-label={label}>
        {inner}
      </Link>
    );
  }
  return (
    <button type="button" className={className} aria-pressed={onClick ? on : undefined} aria-label={label} onClick={onClick}>
      {inner}
    </button>
  );
}
